import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { TAuthStage, TSignInPayload } from '@/services/auth';

import { notifyMeta } from '@/lib/notify';
import { STAFF_KEYS } from '@/constants/queryKeys';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

const useSignIn = () => {
  const queryClient = useQueryClient();

  return useMutation<TAuthStage, Error, TSignInPayload>({
    meta: notifyMeta('authSignIn'),
    mutationFn: async (payload) => {
      errorUtils.unwrap(await authService.signIn(payload));

      const session = errorUtils.unwrap(await authService.readStaffSession());

      queryClient.setQueryData(STAFF_KEYS.session(), session);

      return session.stage;
    },
  });
};

export {
  useSignIn,
};
